module.exports = __webpack_public_path__ + "static/media/codeimage.24b4f27c.svg";